import { memo } from 'react';
import { connect } from 'react-redux';

import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { Row } from 'UIPackage/FormModule/components/Row';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';

import styles from './ErknmOtherInfo.module.scss';
import { ReactQuillEditorField } from '../../../UIPackage/MainModule/components/ReactQuillEditorField';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { getKnmFormRef } from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface IErknmSelectionProps {
  watchOnly: boolean;
  isSelection: boolean | undefined;
}

interface IErknmSelectionStoreProps {
  formRef: IKnmFormRef | undefined;
}

export const ErknmSelectionWithoutStore = memo(
  ({ watchOnly, isSelection, formRef }: IErknmSelectionProps & IErknmSelectionStoreProps) => {
    return (
      <>
        <Row title="Сведения об отборе проб (образцов) продукции (товаров)">
          <SelectInputField
            className={styles.SelectField}
            id="isSelection"
            name="isSelection"
            options={booleanSelectOptions}
            size="medium"
            isClearable={false}
            disabled={watchOnly}
          />
        </Row>
        <Row>
          {isSelection && (
            <FieldBlock>
              <ReactQuillEditorField
                name="selectionReactQuillEditor"
                disabled={watchOnly}
                handleCustomChange={(e: string) => {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  formRef?.current?.change(`selection` as any, e);
                }}
              />
            </FieldBlock>
          )}
        </Row>
      </>
    );
  },
);

const mapStateToProps = (state: IRootState): IErknmSelectionStoreProps => ({
  formRef: getKnmFormRef(state),
});

export const ErknmSelection = connect(mapStateToProps)(ErknmSelectionWithoutStore);
